export default __webpack_public_path__ + "static/media/previous.f12177ef.svg";